import { compact } from "lodash"
import { parse, format, isToday, isYesterday } from "date-fns"

export function addUnique(array, items) {
  const copied = [ ...items ]
  while(copied.length != 0) {
    if (!array.includes(copied[0]))
      break

    copied.shift()
  }

  return [ ...array, ...copied ]
}

export function formatDayOfMessage(dateString, previousDateString = null) {
  const date = parse(dateString, "yyyy-MM-dd", new Date())
  const previousDate = parse(previousDateString, "yyyy-MM-dd", new Date())

  if (isToday(date))
    return "today"
  if (isYesterday(date))
    return "yesterday"

  const sameYear = previousDate.getFullYear() == date.getFullYear()
  const formatString = compact(["MMMM d",  sameYear ? null : 'yyyy']).join(", ")
  return format(date, formatString)
}

export const groupMessagesByDate = messages => messages.reduce((acc, item) => {
  const date = new Date(item.posted_at);
  const key = format(date, "yyyy-MM-dd");

  (acc[key] ||= []).push(item)
  return acc
}, {})